import { render, staticRenderFns } from "./EmployeeInformation.vue?vue&type=template&id=0af7f845&"
import script from "./EmployeeInformation.vue?vue&type=script&lang=js&"
export * from "./EmployeeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports